export default __webpack_public_path__ + "static/media/review-3.2f8aa572.jpg";